import { Component } from '@angular/core';
import { User } from './models/user.model';
import { Router } from '@angular/router';
import { AuthService } from './modules/auth/auth.service';
import { ToastService } from './common/services/toast/toast-service';

@Component({
  selector: 'app-root',
  template:
    '<router-outlet></router-outlet><app-toasts aria-live="polite" aria-atomic="true"></app-toasts>',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'admin-frontend';
  currentUser!: User;

  constructor(
    private router: Router,
    private authenticationService: AuthService,
    private readonly toastService: ToastService,
  ) {
    this.authenticationService.currentUser.subscribe(
      (x) => (this.currentUser = x),
    );
  }
}
